import { render, staticRenderFns } from "./DecisionTargetFormModal.vue?vue&type=template&id=1bdca038&"
import script from "./DecisionTargetFormModal.vue?vue&type=script&lang=js&"
export * from "./DecisionTargetFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports